var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('div',{staticClass:"background-clouds",style:('height:' + _vm.height + 'px')},[_vm._l((_vm.generatedElements),function(element,key){return [_c(element.element,{key:key,tag:"component",style:(_vm.cloudStyle(element))})]})],2):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"component-size-calculator"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }